import CallServer from '../../api/CallServerV2';
export async function fetchCustomizationsSetting () {
    return await CallServer({
        endpoint: '/admin/get_customization_settings',
        isGet: true
    })
} 

export async function fetchAvailableGoogleFonts (family) {
    return await CallServer({
        params: {
            capability:'WOFF2',
            ...(family && {
                'family': family
            })
        },
        customUrl: true,
        endpoint: 'https://www.googleapis.com/webfonts/v1/webfonts?key=AIzaSyBApRxWhjVgzW5Fz_SUz3XwL9pYHMggRQ8',
        needAuthenticate: false,
        isGet: true
    })
} 

export async function fetchUpdateCustomizations (update_data) {
    return await CallServer({
        endpoint: '/admin/update_customization_settings',
        body: update_data,
        isGet: false
    })
} 